export interface UseComponentMapper<T extends string> {
  isComponentAlias: (alias: string) => alias is T;
  getComponentByAlias: (alias: string) => Component | null;
}

export function useComponentMapper<T extends string>(
  compMapperList: Record<T, () => Promise<Component>>
): UseComponentMapper<T> {
  function isComponentAlias(alias: string): alias is T {
    return Object.keys(compMapperList).includes(alias);
  }

  function getComponentByAlias(alias: string): Component | null {
    if (!isComponentAlias(alias)) {
      return null;
    }

    return defineAsyncComponent(compMapperList[alias] as () => Promise<Component>);
  }

  return {
    isComponentAlias,
    getComponentByAlias,
  };
}
